import React from 'react';
import { RISK_LEVELS, RISK_UNKNOWN } from '../theme';

function RiskLight({ rating }) {
  if (!rating) {
    return (
      <span title="Ainda não avaliado" className="inline-flex items-center gap-1 text-xs text-slate-400">
        <span className="h-2 w-2 rounded-full border border-slate-300" />
        Não avaliado
      </span>
    );
  }
  const meta = RISK_LEVELS[rating.level] || RISK_UNKNOWN;
  return (
    <span
      title={rating.reason || meta.label}
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${meta.badge}`}
    >
      <span className={`h-2 w-2 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
}

export default RiskLight;
